// extracted by mini-css-extract-plugin
export default {"empty_list":"empty_list__38e4b3c6","white":"white__38e4b3c6","black":"black__38e4b3c6"};